import { render, staticRenderFns } from "./QBaseshopStats.vue?vue&type=template&id=33b20948&"
import script from "./QBaseshopStats.vue?vue&type=script&lang=js&"
export * from "./QBaseshopStats.vue?vue&type=script&lang=js&"
import style0 from "./QBaseshopStats.vue?vue&type=style&index=0&id=33b20948&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports